var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "cd" },
    [
      _c(_setup.WaitMessage, { attrs: { ob: _setup.wdrob } }),
      _vm._v(" "),
      !_setup.wdrob.wait && _setup.wdrob.message
        ? _c("div", [
            _c(
              "button",
              {
                staticClass: "btn btn--blue",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _setup.cancel.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Начать заново")]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_setup.wdrob.wait && !_setup.wdrob.message
        ? _c("div", [
            _c("h2", [
              _vm._v(
                "\n            Прошу выплатить вознаграждение в размере " +
                  _vm._s(_setup.wdrob.claim.reward.sum) +
                  "р. \n        "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "cd__line" },
              [
                _vm._v("Способ выплаты вознаграждение: "),
                _c(_setup.ShowAcc, {
                  attrs: { acc: _setup.wdrob.wdr.account },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "cd__line" },
              [
                _vm._v(
                  "Подтверждаю, что я ознакомлен(а) со всеми необходимыми документами:\n            "
                ),
                _vm._l(_setup.wdrob.docs, function (doc) {
                  return _c("div", { staticClass: "cd__doc" }, [
                    _c("a", { attrs: { href: doc.url, target: "_blank" } }, [
                      _vm._v(_vm._s(doc.type_str)),
                    ]),
                  ])
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                  },
                },
              },
              [
                !_setup.for_confirm.is
                  ? _c("div", { staticClass: "cd__buts" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn--blue",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _setup.confirm(true)
                            },
                          },
                        },
                        [_vm._v("Подтвердить по смс")]
                      ),
                      _vm._v(" "),
                      !_setup.disable_dontsend
                        ? _c(
                            "button",
                            {
                              staticClass: "btn",
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _setup.confirm(false)
                                },
                              },
                            },
                            [_vm._v("подтвердить без реальной смс (тест)")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn--blue",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _setup.cancel.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v("Отменить")]
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _setup.for_confirm.is
              ? _c(
                  "div",
                  [
                    _c(_setup.DoConfirm, {
                      attrs: {
                        wdr_sid: _setup.props.wdr_sid,
                        dontsend: _setup.for_confirm.dontsend,
                      },
                      on: { input: _setup.after_confirm },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }